(ns frontend.view.settings2.screening.view
  (:require [common.localization :as loc]
            [frontend.logging :as logging]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.sales-pipelines.db :as db]
            [frontend.view.settings2.screening.events :as events]
            [reagent.core :as r]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.editors.labelled-input.view :as labelled-input]
            [common.util :as cu]))

(defn toolbar-buttons
  []
  [#_{:toolbar-button? true
      :dropdown-action? true
      :ord             0
      :icon            :fa-plus
      :primary-button? true
      :disabled?       (not (session/has-feature-access? :feature/sales-pipelines))
      :tooltip         (when (not (session/has-feature-access? :feature/sales-pipelines))
                         (loc/tr :feature-not-enabled))
      :on-select       (fn [e]
                         (f-entity/open-creator! :entity.type/pipeline
                                                 {:start-value {:pipeline/entity-type
                                                                :entity.type/sales-opportunity}
                                                  :on-ok!      (fn [new-entity-id close-cb!]
                                                                 (close-cb!))}))
      :label           (loc/tr :settings.sales-pipelines/toolbar-create-pipeline)}
  ])

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/screening)]])

(defn general-configuration
  [tenant-cursor]
  (let [state (r/atom nil)]
    (fn []
      (let [screening-service :screening-service/risk-screen ; Hard coded for now
            options [{:value :screening-service/risk-screen :label "RiskScreen"}]]
        [:div
         [:div
          {:class "flex flex-col gap-4"}
          [:span
           {:class "font-semibold text-xl"}
           (loc/tr :settings.screening/heading)]
          [:div
           {:class "flex flex-col gap-4"}
           [:div
            [labelled-input/view
             {:label "Screening service"
              :data-type :data.type/keyword
              :value    (->> options
                             (cu/filter-by :value screening-service)
                             (first))
              :options options
              :on-change  (fn [_]
                            nil)}]]

           (condp = screening-service
             :screening-service/risk-screen
             (let [attribute :tenant/risk-screen-api-key
                   old-value (get @tenant-cursor attribute)]
               [:div
               [labelled-input/view
                {:label "RiskScreen API key"
                 :data-type :data.type/text-simple
                 :value     old-value
                 :on-change (fn [new-value]
                              (swap! tenant-cursor assoc attribute new-value))
                 :on-blur  (fn [new-value]
                             (events/save-tenant!
                              (:db/id @tenant-cursor)
                              attribute
                              new-value
                              (fn [res]
                                (logging/info "Update successful"))
                              (fn [err]
                                (logging/error "Failed to save RiskScreen API key" err))))}]])
             nil)]]]))))

(defn component
  []
  (let [tenant-id (:db/id @session/tenant)
        tenant-cursor (r/cursor session/entities [tenant-id])]
    (fn []
      [:<>
       [zap-toolbar/view db/state breadcrumbs nil (toolbar-buttons)]
       [:div
        {:class "bg-base-light text-base-light-text h-[calc(100vh_-_52px-_37px)] overflow-auto"}
        [:div
         {:class "px-4 py-6 mx-auto max-w-5xl"}
         [general-configuration tenant-cursor]]]])))


(defmethod routing/render-view :settings/screening
  [_]
  (if true
    [default-page-layout/view
     [component]]
    [not-found/not-found-view]))
